<template>
  <CRow v-if="companyData" class="m-0">
    <CCol cols="12" lg="12" class="pt-0">
      <span class="d-block mb-2"><b>{{$t('admin.2fa_required_for_dashboard_login')}}</b></span>
      <b-switch class="m-0" v-model="companyAuthenticationRequired" size="is-small" @input="confirmModal = true;">
        <span>{{companyAuthenticationRequired ? $t('Yes') : $t('No')}}</span>
      </b-switch>
      
      <b-modal :can-cancel="['x']" :active.sync="confirmModal" :width="960" scroll="keep">
        <CCard class="mb-0">
          <CCardHeader class="pb-0">
            <span>{{companyAuthenticationRequired ? $t('admin.Make_2fa_required_for_logins') : $t('admin.Make_2fa_not_required_for_logins')}}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol cols="12" lg="12" class="pt-0 pb-0">
                <span>{{companyAuthenticationRequired ? $t('admin.Are_you_sure_to_make_2fa_required', { company_name : companyData.details.company_name}) : $t('admin.Are_you_sure_to_make_2fa_not_required', { company_name : companyData.details.company_name})}}</span>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="confirmAuthenticationRequiredUpdate();"><i class="fas fa-check mr-1"/>{{companyAuthenticationRequired ? $t('admin.Make_2fa_required') : $t('admin.Make_2fa_not_required')}}</CButton>
            <CButton color="secondary" @click="cancelAuthenticationRequiredUpdate()"><i class="fas fa-times mr-1"/>{{ $t('Cancel') }}</CButton>
          </CCardFooter>
        </CCard>
      </b-modal>    
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TwoFactorAuthenticationEnabled',
  props: ['companyData'],
  watch: {
    companyData: {
      handler() {
        if(this.companyData && this.companyData.authentication_required) {
          this.companyAuthenticationRequired = this.companyData.authentication_required;
        }
      },
      deep: true,
      immediate: true
    }
  },  
  data() {
    return {
      updateApiMessage: null,
      companyAuthenticationRequired: false, 
      confirmModal: false
    }
  },
  methods: {
    confirmAuthenticationRequiredUpdate() {
      // Set the updateApiPath and updateApiMessage values
      if(this.companyAuthenticationRequired) {
        this.updateApiMessage = this.$t('admin.Made_2fa_required', { company_name : this.companyData.details.company_name});
      } else {
        this.updateApiMessage = this.$t('admin.Made_2fa_not_required', { company_name : this.companyData.details.company_name});
      } 

      axios.put(process.env.VUE_APP_API_URL + '/v1/core/company/authentication/status')
      .then(res => {
        this.$buefy.toast.open({ message: this.updateApiMessage, type: 'is-success', duration: 2000 });
        // Close the modal
        this.confirmModal = false;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    cancelAuthenticationRequiredUpdate() {
      this.companyAuthenticationRequired = !this.companyAuthenticationRequired;
      // Close the modal
      this.confirmModal = false;
    }  
  }
}
</script>